<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="10">
            <el-input placeholder="输入账户信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>     
          <el-col :span="10">
          <el-select placeholder="请选择业务部门" v-model="query.department" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
          </el-col>    
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="exportFile">导出文书</el-button>
          </el-col>
          <!-- <el-col :span="4">
            <span>
              <el-button type="primary" size="small"  @click="doExport">导出风险准备金转移记录</el-button>
            </span>
          </el-col> -->
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
             <el-table-column
              type="selection"
              width="30">
            </el-table-column>
            <el-table-column align="left" label="会员">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="转让账户">
              <template slot-scope="scope">
                <span>{{scope.row.account_number}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="转让船舶">
              <template slot-scope="scope">
                <span>{{scope.row.ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="接收账户">
              <template slot-scope="scope">
                <span>{{scope.row.recipient_account_number}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="接收船舶">
              <template slot-scope="scope">
                <span>{{scope.row.recipient_ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="业务归属部门">
              <template slot-scope="scope">
                <span>{{scope.row.department}}</span>
              </template>
            </el-table-column>
       
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 申请时间 -->
            <el-table-column align="left" label="申请时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="转让金额">
              <template slot-scope="scope">
                <span>{{ scope.row.balance }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="状态">
              <template slot-scope="scope">
                <span>{{ scope.row.status_name}}</span>
              </template>
            </el-table-column>

            
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[0].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="审核" placement="top-start" v-if="scope.row.status === 3 && $perm(['member.move_account_apply'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="light" content="审核不通过" placement="top-start" v-if="scope.row.status === 0 && $perm(['member.move_account'])">
                    <el-button type="text" class="pr-1" @click="handleReject(scope.row)">
                        <i class="el-icon-s-release"></i>
                    </el-button>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
            <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              :ship-list="shipList" 
              :customer-list="customerList"
              object-type="member.accountapply"
              :object-id="apply_id"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
        </div>
      </el-card>

    <el-dialog :visible.sync="formVisible" width="50%" title="导出船舶退会/变更申请书">
      <el-form ref="dataForm" :model="quitForm" label-position="top" label-width="120px" class="mx-30">
        <el-form-item label="请选择变更原因" >
          <el-radio v-model="quitForm.reason" label="1">报废</el-radio>
          <el-radio v-model="quitForm.reason" label="2">转让</el-radio>
          <el-radio v-model="quitForm.reason" label="3">其他</el-radio>
        </el-form-item>
        <el-form-item label="其他原因" v-show="quitForm.reason === '3'">
          <el-input  type="textarea" :rows="4" placeholder="请输入其他原因"  v-model="quitForm.other_reason" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="请选择是否保留会籍">
          <el-radio v-model="quitForm.reserve" label="1">保留</el-radio>
          <el-radio v-model="quitForm.reserve" label="2">不保留</el-radio>
        </el-form-item>
        <el-form-item label="签署日期">
              <el-date-picker
                v-model="quitForm.write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelShipQuitVisible">取消</el-button>
        <el-button type="primary" @click="exportShipQuit">导出</el-button>
      </span>
    </el-dialog>
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import UploadDialog from "@/components/UploadDialog"
    import { fetchFileTypeList } from "@/api/common"
    import { fetchList as fetchGroupList } from "@/api/group";
    import {rejectTransferApply,transferSuccess,accountApplyList,
      exportShipTransfer, submitAccountApply, exportShipQuitApply} from '@/api/member'
  
    export default {
      name: "AccountApplyList",
      components: {
        PaginationNew,
        UploadDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          object_name:"",
          apply_id:'',
          file_type_list:[],
          shipList:[],
          customerList:[],
          groupList:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
          },
          searching: false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          multipleSelection: [],
          total: 0,
          formVisible:false,
          quitForm: {}
        }
      },
      methods: {
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "sc|cc|bc"}))
          p.push(fetchGroupList())

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
            this.groupList = res[1]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          let ship_obj = {"id":row.recipient_ship_id,"name":row.recipient_ship_name}
          let customer_obj = {"id":row.customer_id,"name":row.customer_name}
          this.customerList.push(customer_obj)
          this.shipList.push(ship_obj)
          this.apply_id = row.id
          this.object_name = row.ship_name
          this.$refs.upload.handleOpen()
        },
        handleSubmit(row) {
            this.$confirm('提交审核后，将不能再修改, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                submitAccountApply({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        doExport: function(){
          exportShipTransfer()
          .then(res=>{
            let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = '账户转移记录' + '.xlsx'
            document.body.appendChild(link)

            link.click()
            URL.revokeObjectURL(blob)
            document.body.removeChild(link)
          }).catch(err =>{
            this.$error_message(err)
          })
      },
        handleReject(row) {
          var msg = '是否拒绝该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            rejectTransferApply({'id':row.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '拒绝成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        handleSuccess(row) {
          this.setQueryStorage()
          this.$router.push({ name: 'accountApplyDetail', query: {'type': 'accountApply', 'id': row.id}})
        },
        handleUpdate(row){
          this.setQueryStorage()
          this.$router.push({ name: 'accountApplyDetail', query: {'type': 'ViewAccountApply', 'id': row.id}})
        },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleSearch() {
          this.getList()
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          accountApplyList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        cancelShipQuitVisible(){
          this.formVisible = false
          this.quitForm = {}
        },
        exportFile(){
          this.quitForm = {}
          if (this.multipleSelection.length !== 1) {
            this.$error_message("请选择一笔申请！")
            return
          }
          this.quitForm.type = '4'
          this.quitForm.second_type = 'account_apply'
          this.formVisible = true
        },
        exportShipQuit(){
          if ( !this.quitForm.reason ) {
            this.$error_message("请选择退会原因！")
            return
          }
          exportShipQuitApply({data:this.multipleSelection, reason:this.quitForm})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "船舶退会/变更申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.formVisible = false
            })
            .catch(error => {
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20
            
          }
        this.getList()
        this.loadData()
      }
    }
  </script>
  